import React, {Component} from "react";
import PropTypes from "prop-types";
import ProjectModel from "../models/project";
import ProjectListItem from "./ProjectListItem";

export default class ProjectList extends Component {
    renderProjects() {
        if (this.props.projects === undefined) {
            return;
        }

        let projects = [];

        this.props.projects.forEach((project) => {
            let isActive = project.id === this.props.selectedProject;
            projects.push(
                <ProjectListItem
                    key={project.id}
                    model={project}
                    isActive={isActive}
                    onClick={this.props.onSelectedProjectChanged}
                />);
        });

        return projects;
    }

    render() {
        return (
            <ul className="list-group">
                {this.renderProjects()}
            </ul>
        )
    }
}

ProjectList.propTypes = {
    projects: PropTypes.arrayOf(PropTypes.instanceOf(ProjectModel)).isRequired,
    selectedProject: PropTypes.number,
    onSelectedProjectChanged: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/ProjectList.js